import 'babel-polyfill'
import '../config/polyfill'
import Common from './Common'
import NaviPc from './NaviPc'
import NaviSp from './NaviSp'
import LIB from '../utility/Library'
import scrollHandler from '../motion/ScrollHandler'
import Transition from '../motion/Transition'
import Title from '../motion/Title'

window.addEventListener('load', () => {
  const navi       = LIB.isPc ? new NaviPc() : new NaviSp()
  const transition = new Transition()
  const title      = new Title()

  // スクロールイベントに、各インスタンスを登録する
  scrollHandler.init()
  scrollHandler.addInstances(navi, transition, title)
  scrollHandler.bindScroll()

  // TODO: temporary workaround for chrome's scroll jitter bug
  // from ScrollMagic
  window.addEventListener("mousewheel", function () {})

  // 全ページ共通処理
  const common = new Common()

  // デバイスのクラス
  document.body.classList.add(LIB.Visitor().type)
  document.body.classList.add(LIB.Visitor().device.os)
  if (LIB.isOldIos) {
    document.body.classList.add('old-ios')
  }
  if (LIB.isOldAndroid) {
    document.body.classList.add('old-android')
  }

  if (location.hash) {
    navi.onLoad()
  } else {
    document.body.classList.add('is-loaded')
  }
  scrollHandler.triggerScroll()
})


// WEBPACK FOOTER //
// ./src/assets/js/common/entry.js